/* @refresh reload */
import { render } from "solid-js/web";
import { QueryClientProvider } from "@tanstack/solid-query";
import { App } from "@/App";
import { queryClient } from "@/lib/queryClient";
import { initAuthStore } from "@/auth/store";
import { isAuthConfigured } from "@/config/env";
import { initTheme } from "@/lib/themeService";
import { initDebug } from "@/lib/debug";
import { initGoogleAnalytics } from "@/lib/googleAnalytics";
import "@/styles/global.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}

// Initialize diagnostics and theme before rendering so boot-time failures are visible.
initDebug();
initTheme();
initGoogleAnalytics();

if (isAuthConfigured()) {
  void initAuthStore();
}

render(
  () => (
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  ),
  root,
);
